import WishlistHeading from './wishlist-heading'
export default WishlistHeading
